import React from 'react'
import { t } from 'ttag'

import h2CoreWobbler from '@h2/assets/svg/illustrations/h2CoreWobbler.svg'

const initialState = {
  defaultMediaContent: [
    {
      displayName: t`Logo`,
      imgUrl: '/images/assets/horizontal/dark.svg',
      items: [
        {
          title: 'Full Logo',
          size: `1780 x 332px`,
          format: `PNG`,
          url: '/images/assets/horizontal/dark.png'
        },
        {
          title: 'Full Logo',
          size: `1780 x 332px`,
          format: `JPG`,
          url: '/images/assets/horizontal/dark.jpg'
        },
        {
          title: 'Full Logo',
          size: `vector`,
          format: `SVG`,
          url: '/images/assets/horizontal/dark.svg'
        },
        {
          title: 'Full Logo',
          size: `vector`,
          format: `EPS`,
          url: '/images/assets/horizontal/dark.eps'
        }
      ]
    },
    {
      displayName: t`Logo (Vertical)`,
      imgUrl: '/images/assets/vertical/dark.svg',
      items: [
        {
          title: 'Full Logo (Vertical)',
          size: `332 x 1780px`,
          format: `PNG`,
          url: '/images/assets/vertical/dark.png'
        },
        {
          title: 'Full Logo (Vertical)',
          size: `332 x 1780px`,
          format: `JPG`,
          url: '/images/assets/vertical/dark.jpg'
        },
        {
          title: 'Full Logo (Vertical)',
          size: `vector`,
          format: `SVG`,
          url: '/images/assets/vertical/dark.svg'
        },
        {
          title: 'Full Logo (Vertical)',
          size: `vector`,
          format: `EPS`,
          url: '/images/assets/vertical/dark.eps'
        }
      ]
    },
    {
      displayName: t`Icon`,
      imgUrl: '/images/assets/avatar/dark.svg',
      items: [
        {
          title: 'Icon',
          size: `1654 x 1654px`,
          format: `PNG`,
          url: '/images/assets/avatar/dark.png'
        },
        {
          title: 'Icon',
          size: `1654 x 1654px`,
          format: `JPG`,
          url: '/images/assets/avatar/dark.jpg'
        },
        {
          title: 'Icon',
          size: `vector`,
          format: `SVG`,
          url: '/images/assets/avatar/dark.svg'
        },
        ,
        {
          title: 'Icon',
          size: `vector`,
          format: `EPS`,
          url: '/images/assets/avatar/dark.eps'
        }
      ]
    }
  ],
  tenantMedia: {
    nevada: [
      {
        displayName: t`Posters`,
        imgUrl: '/images/headed2/new/media/Poster.svg',
        items: [
          {
            title: 'Five Reasons to Career Plan',
            size: `8.5" x 11"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=17-xZpsXKyF18lc4pGNXHM57u6FsDoSTZ',
            restrictToSubTenant: 'wcsd'
          },
          {
            title: 'Five Reasons to Use Nevada CareerExplorer in High School',
            size: `8.5" x 11"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1fVFvUI6bVWFgu7FulTksu8QFF6Kkpfbd',
            restrictToSubTenant: 'wcsd'
          },
          {
            title: 'Five Reasons to Use Nevada CareerExplorer in Middle School',
            size: `8.5" x 11"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1qX7hMGJVyhsZP-bYhZJQf-hFubWtxPnv',
            restrictToSubTenant: 'wcsd'
          },
          {
            title: 'Boulder City Libraries',
            size: `8.5" x 11"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=12UNI6KEjGgYA0h0-BikfrDbGWwrW4DYw'
          },
          {
            title: 'Boulder City Libraries',
            size: `8.5" x 11"`,
            format: t`PDF - For professional printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1hkDMjIcptzC_OuPJI93GM912b8c-MsoW'
          },
          {
            title: 'Clark County Libraries',
            size: `8.5" x 11"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1ttwjQhD1IftuineUo4t5jYbXfpM9Bo2B'
          },
          {
            title: 'Clark County Libraries',
            size: `8.5" x 11"`,
            format: t`PDF - For professional printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1e_7HgIVpHfP_iXmh8_aUl0DGg2OeZO1F'
          },
          {
            title: 'Henderson Libraries',
            size: `8.5" x 11"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1zjcy9hlouqAHwdhWseRjmbbvfxymHAjG'
          },
          {
            title: 'Henderson Libraries',
            size: `8.5" x 11"`,
            format: t`PDF - For professional printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1pGOczSqrjdAinEyzDP8MAOxCkDr7FYn9'
          },
          {
            title: 'North Las Vegas Libraries',
            size: `8.5" x 11"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1TMA8VhEmp3WYew75r0OqWxhuctx8PGeC'
          },
          {
            title: 'North Las Vegas Libraries',
            size: `8.5" x 11"`,
            format: t`PDF - For professional printing`,
            url:
              'https://drive.google.com/uc?export=download&id=10op_hyeDiSgg8eYjsFsVag5L9bCdxY0f'
          }
        ]
      },
      {
        displayName: t`Bookmarks`,
        imgUrl: '/images/headed2/new/media/Bookmark.svg',
        items: [
          {
            title: 'Boulder City Libraries',
            size: `2.2" x 7.8"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1AM6muOsLn6VEAJEj01uiJoRLgOSciI9x'
          },
          {
            title: 'Boulder City Libraries',
            size: `2.2" x 7.8"`,
            format: t`PDF - For professional printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1D0OLN8HB0pft2iOIxw37NXhuumzAiK2Q'
          },
          {
            title: 'Clark County Libraries',
            size: `2.2" x 7.8"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1R8ZKScjvovfYe4PLp5iajQC2wGzgr1Nz'
          },
          {
            title: 'Clark County Libraries',
            size: `2.2" x 7.8"`,
            format: t`PDF - For professional printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1LMybrE4zRvOsVe_1Sp2rg4BDJkCM-5h_'
          },
          {
            title: 'Henderson Libraries',
            size: `2.2" x 7.8"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1RjqRuIzeEkarQXucnv0w0i4LyTamSh75'
          },
          {
            title: 'Henderson Libraries',
            size: `2.2" x 7.8"`,
            format: t`PDF - For professional printing`,
            url:
              'https://drive.google.com/uc?export=download&id=13kCaxW2vVyLye7fzCglojheJNx_tAn8N'
          },
          {
            title: 'North Las Vegas Libraries',
            size: `2.2" x 7.8"`,
            format: t`PDF - For in-house printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1feULAEyd4z-pi5C1ygn7cQK9K0wJIS3M'
          },
          {
            title: 'North Las Vegas Libraries',
            size: `2.2" x 7.8"`,
            format: t`PDF - For professional printing`,
            url:
              'https://drive.google.com/uc?export=download&id=1t8I3DfPJYbYU4T6GSR9MsuKDohH62Jss'
          }
        ]
      },
      {
        displayName: t`Wobblers`,
        imgUrl: h2CoreWobbler,
        items: [
          {
            title: 'Shelf Wobbler for North Las Vegas Libraries',
            size: `8.5" x 11"`,
            format: `PDF`,
            url:
              'https://drive.google.com/uc?export=download&id=1tzI0KDgQd4Ln7De4ToeWiLeDBT2SBQ9Z'
          },
          {
            title: 'Shelf Wobbler for Henderson Libraries',
            size: `8.5" x 11"`,
            format: `PDF`,
            url:
              'https://drive.google.com/uc?export=download&id=1dasevqsDmTqAJKnXEtV84m5xhtyLRH85'
          },
          {
            title: 'Shelf Wobbler for Clarke County Libraries',
            size: `8.5" x 11"`,
            format: `PDF`,
            url:
              'https://drive.google.com/uc?export=download&id=1St1KulKiVaEPmmABNFlNIeRSPo5y6yLo'
          },
          {
            title: 'Shelf Wobbler for Boulder City Libraries',
            size: `8.5" x 11"`,
            format: `PDF`,
            url:
              'https://drive.google.com/uc?export=download&id=1HPPuA9L4d0fG8_OshC_0hbhWMD9CT8aV'
          }
        ]
      }
    ]
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}
